
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/orders",
      function () {
        return require("private-next-pages/brands/orders.ts");
      }
    ]);
  